import React from 'react';
import { useScrollReveal } from '../../../hooks/useScrollReveal';
import FlipCard from '../../../components/effects/FlipCard';

interface RecentProjectsProps {
  isLoaded: boolean;
}

interface ProjectCardData {
  name: string;
  type: string;
  suit: '♠' | '♦' | '♣' | '♥';
  description: string;
  tags: string[];
}

const PROJECTS: ProjectCardData[] = [
  {
    name: 'Casino Platform',
    type: 'Multiplayer',
    suit: '♠',
    description: 'Pixel art casino lobby with four card games, real-time multiplayer via Socket.io, chip wagering, and RPG battle UI',
    tags: ['Canvas 2D', 'Socket.io', 'TypeScript'],
  },
  {
    name: 'Word Hunter',
    type: 'Typing Game',
    suit: '♦',
    description: 'Enemy-rush typing game with wave progression, bomb/streak enemies, safe zone mechanic, and pixel art character dialogue',
    tags: ['React', 'Canvas 2D', 'TypeScript'],
  },
  {
    name: 'PM Dashboard',
    type: 'Internal Tool',
    suit: '♣',
    description: 'Private team dashboard with pixel office scene, GitHub/Slack sync, AI learning modules from commit history',
    tags: ['D3', 'Socket.io', 'AI'],
  },
  {
    name: 'CASA Website',
    type: 'Web Design',
    suit: '♥',
    description: 'Non-profit website redesign for Mitchell First Circuit CASA — HTML/CSS/JS with Adobe After Effects video',
    tags: ['HTML', 'CSS', 'JavaScript'],
  },
];

const RecentProjects: React.FC<RecentProjectsProps> = ({ isLoaded }) => {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <div
      ref={ref}
      className={`projects-section scroll-reveal ${isVisible ? 'is-visible' : ''} ${isLoaded ? 'animate-in' : ''}`}
    >
      <h2 className="section-title">RECENT PROJECTS</h2>
      <ul className="project-list">
        {PROJECTS.map((p) => (
          <li key={p.name} className="project-item">
            <FlipCard
              ariaLabel={`${p.name} — ${p.type}. Activate to flip.`}
              front={
                <div className="flip-card-face flip-card-face--front">
                  <span className="flip-card-suit" aria-hidden="true">{p.suit}</span>
                  <h3 className="flip-card-name">{p.name}</h3>
                  <span className="flip-card-type">{p.type}</span>
                  <span className="flip-card-hint flip-card-hint--hover">hover to flip</span>
                  <span className="flip-card-hint flip-card-hint--tap">tap to flip</span>
                </div>
              }
              back={
                <div className="flip-card-face flip-card-face--back">
                  <p className="flip-card-description">{p.description}</p>
                  <div className="flip-card-tags">
                    {p.tags.map((t) => (
                      <span key={t} className="flip-card-tag">{t}</span>
                    ))}
                  </div>
                </div>
              }
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default React.memo(RecentProjects);
